
import axios from 'axios';
import { SEALOS_HOSPITAL_API_URL } from './baseUrls';

// 设置基础 URL
const API_URL = SEALOS_HOSPITAL_API_URL;

// 获取患者信息的请求函数
export const getbinganConfig = async (flag) => {
    try {
        const response = await axios.get(`${API_URL}/bingancofig`, {
            params: {
                flag,
            }
        });
        console.log('获取病案管理系统配置成功', response.data);

        return response.data; // 返回患者信息
    } catch (error) {
        console.error("获取病案管理系统配置失败:", error);
        throw error; // 抛出错误以便调用者处理
    }
};
